﻿import { SearchGateway } from './search.gateway';
import { SearchViewModel } from './search.viewmodel';
import { SearchResultModel } from './search.viewmodel';
import * as LogService from "../../core/services/logservice/log.service";
import * as Model from '../../models/models';
import { SubmissionStateService } from '../../core/services/submissionStateService/submissionState.service';
import IAppSettings from '../../../iApp.settings';

export class SearchController {

    private searchViewModel: SearchViewModel;
    private searchCriteriaModel: Model.ISubmissionSearchCriteria;

    static $inject = ['$window', '$state', 'logService', 'search.gateway', 'submissionStateService', 'appSettings'];

    constructor(private $window: ng.IWindowService,
        private $state: ng.ui.IStateService,
        private logger: LogService.ILogService,
        private searchGateway: SearchGateway,
        private submissionStateService: SubmissionStateService,
        private appSettings: IAppSettings) {

        this.searchCriteriaModel = new Model.SubmissionSearchCriteria();
    }

    public submit(): void {
        // if searchResultsGrid is already loaded then clear it so the spinner does not spin on top of data
        if (typeof (this.searchViewModel) !== "undefined") {
            if (typeof (this.searchViewModel.searchResults) !== "undefined") {
                this.searchViewModel.searchResults = undefined;
            }
        }

        const searchViewModelPromise: ng.IPromise<SearchViewModel> = this.searchGateway.loadSearchViewModel(this.searchCriteriaModel);
        searchViewModelPromise.then((viewModel: SearchViewModel) => {
            this.logger.debug("searchViewModelPromise", viewModel);
            this.searchViewModel = viewModel;
        });
    }

    public onStartWizard(submissionId: string): void {
        this.submissionStateService.submissionId = submissionId;
        this.$window.location.href = this.appSettings.backOfficeSiteName + "/submission/" + submissionId + "/info";
    }

    public editRatingFactors(searchResult: SearchResultModel): void {
        this.$state.go('shellFrame.administrationFrame.quickEdit', { submissionId: searchResult.submissionId });
    }
}
